<template lang="pug">
  v-card.mb-3
    v-card-title.title(v-if="options.show_panel_title") {{extra.name}}
    template(v-if="msg")
      v-alert(type="success" :value="true") {{msg}}
    template(v-else)
      v-card-text(v-if="edit")
        v-layout(row wrap)
          template(v-for="field in form")
            template(v-if="field === 'user_or_name_and_email'")
              template(v-if="user")
                v-flex(xs12 sm6): v-text-field(label="Vorname" v-model="user.vorname" disabled :error-messages="gqlErrorsFor('formEntryCreate', 'user')")
                v-flex(xs12 sm6): v-text-field(label="Nachname" v-model="user.nachname" disabled)
              template(v-else)
                v-flex(xs12 sm6): v-text-field(label="Vorname" v-model="edit.vorname" :error-messages="gqlErrorsFor('formEntryCreate', 'vorname')")
                v-flex(xs12 sm6): v-text-field(label="Nachname" v-model="edit.nachname" :error-messages="gqlErrorsFor('formEntryCreate', 'nachname')")
                v-flex(xs12): v-text-field(label="E-Mail" v-model="edit.email" :error-messages="gqlErrorsFor('formEntryCreate', 'email')")
            template(v-else)
              template(v-if="fieldType(field) === 'checkbox'")
                v-flex(xs12 :class="fieldSize(field)"): v-checkbox(:label="fieldLabel(field)" v-model="edit[field]" :error-messages="gqlErrorsFor('formEntryCreate', field)")
              template(v-else-if="fieldType(field) === 'string'")
                v-flex(xs12 :class="fieldSize(field)"): v-text-field(:label="fieldLabel(field)" v-model="edit[field]" :error-messages="gqlErrorsFor('formEntryCreate', field)")
              template(v-else-if="fieldType(field) === 'text'")
                v-flex(xs12 :class="fieldSize(field)"): v-textarea(:label="fieldLabel(field)" v-model="edit[field]" :error-messages="gqlErrorsFor('formEntryCreate', field)")
              template(v-else-if="fieldType(field) === 'rating'")
                v-flex(xs12 :class="fieldSize(field)")
                  .caption.grey--text.text--darken-1: div(:class="{ 'error--text': gqlErrorsFor('formEntryCreate', field).length > 0 }") {{fieldLabel(field)}}
                  v-rating(v-model="edit[field]")
                  v-messages(color="error" :value="gqlErrorsFor('formEntryCreate', field)")

      v-card-actions
        v-btn(@click="save" outline color="primary" :loading="loading > 0") {{submitButton}}

</template>

<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import { user } from '../../router'

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  data() {
    return {
      user,
      loading: false,
      msg: null,
      edit: null,
    }
  },
  watch: {
    options: {
      immediate: true,
      handler(options) {
        const edit = {}
        const form = this.form
        const fields = this.fields
        form.forEach(field => {
          const type = fields[field] || {}
          if (field === 'user_or_name_and_email') {
            edit.vorname = ''
            edit.nachname = ''
            edit.email = ''
          } else if (type.as === 'checkbox') {
            edit[field] = null
          } else if (type.as === 'rating') {
            edit[field] = null
          } else {
            edit[field] = ''
          }
        })
        this.edit = edit
      }
    }
  },
  computed: {
    options() {
      return this.extra && this.extra.options || {}
    },
    content() {
      return this.extra && JSON.parse(this.extra.content || null) || {}
    },
    formDefinition() {
      return this.content.fields || {}
    },
    formId() {
      return this.content.id
    },
    form() {
      return this.formDefinition.form
    },
    fields() {
      return this.formDefinition.fields
    },
    successMessage() {
      return this.formDefinition.success_message || 'Erfolgreich Abgesendet'
    },
    submitButton() {
      return this.formDefinition.submit_button || 'Absenden'
    }
  },
  methods: {
    fieldType(field) {
      const fieldType = this.fields[field] || {}
      return fieldType.as || 'string'
    },
    fieldLabel(field) {
      const fieldType = this.fields[field] || {}
      return fieldType.label || field
    },
    fieldSize(field) {
      const fieldType = this.fields[field] || {}
      return fieldType.size || ''
    },
    save() {
      this.loading++
      this.gqlClearAllErrors()
      const fieldsData = []

      const fields = this.fields
      const edit = this.edit
      this.form.forEach(field => {
          if (field === 'user_or_name_and_email') {
            if (this.user) {
              fieldsData.push({ slug: 'userId', string: `${this.user.id}` })
            } else {
              fieldsData.push({ slug: 'vorname', string: edit.vorname })
              fieldsData.push({ slug: 'nachname', string: edit.nachname })
              fieldsData.push({ slug: 'email', string: edit.email })
            }
          } else {
            const type = fields[field] || {}
            if (type.as === 'checkbox') {
              fieldsData.push({ slug: field, boolean: edit[field] })
            } else if (type.as === 'rating') {
              fieldsData.push({ slug: field, integer: edit[field] })
            } else {
              fieldsData.push({ slug: field, string: edit[field] })
            }
          }
        })

      this.$apollo.mutate({
        mutation: gql`mutation (
          $formId: ID!
          $fields: [FormEntryInput!]!
        ) {
          formEntryCreate(
            formId: $formId
            fields: $fields
          ) {
            id
            status
            fields {
              ... on  FormEntryFieldString {
                slug
                string
              }
              ... on FormEntryFieldBoolean {
                slug
                boolean
              }
              ... on FormEntryFieldInteger {
                slug
                integer
              }
              ... on FormEntryFieldFloat {
                slug
                float
              }
              ... on FormEntryFieldDate {
                slug
                date
              }
              ... on FormEntryFieldDateTime {
                slug
                datetime
              }
              ... on FormEntryFieldNone {
                slug
              }
            }
          }
        }`,
        variables: {
          formId: this.formId,
          fields: fieldsData,
        },
      }).then((data) => {
        this.loading--
        this.edit = null
        this.msg = this.successMessage
      }).catch((error) => {
        this.gqlAddErrors(error)
        this.loading--
      })
    }
  }
}
</script>
